import axios from "axios"

class PaymentMethodService {
  api
  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token")

      if (token) {
        config.headers = {
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        }
      }

      return config
    })
  }
  getPayment_methodList = async () => {
    try {
      const response = await this.api.get(`/payment-method/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  getPayment_methodDetails = async (payment_methodId) => {
    try {
      const response = await this.api.get(`/payment-method/${payment_methodId}/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  createPayment_method = async (payment_methodData) => {
    try {
      const response = await this.api.post(
        `/payment-method/`,
        payment_methodData
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  updatePayment_method = async (payment_methodId, payment_methodData) => {
    try {
      const response = await this.api.put(
        `/payment-method/${payment_methodId}/`,
        payment_methodData
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  deletePayment_method = async (payment_methodId) => {
    try {
      const response = await this.api.delete(
        `/payment-method/${payment_methodId}/`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }
  getBillingList = async () => {
    try {
      const response = await this.api.get("/billing/")
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const paymentMethodService = new PaymentMethodService()

export default paymentMethodService
